<template>
  <header id="header" class="container-fluid header">
    <div class="container">
      <div class="row justify-content-between">
        <div class="header-logo-wrapper col-auto">
          <router-link to="/" class="header-logo-link">
            <img
              class="header-logo-link-img"
              src="/images/main_logo.png"
              alt="Rococo Painters Logo"
            />
          </router-link>
        </div>
        <div class="header-navigation-wrapper col-auto">
          <MobileMenu></MobileMenu>
          <ul class="header-navigation-items">
            <li>
              <router-link class="header-navigation-items-link" to="/about-us/">
                About Us
              </router-link>
            </li>
            <li>
              <router-link class="header-navigation-items-link" to="/our-services/">
                Services
              </router-link>
            </li>
            <li>
              <router-link class="header-navigation-items-link" to="/gallery/">
                Gallery
              </router-link>
            </li>
            <li>
              <router-link class="header-navigation-items-link" to="/testimonials/">
                Testimonials
              </router-link>
            </li>
            <li>
              <router-link
                class="header-navigation-items-link"
                to="/contact-us/"
              >
                Contact Us
              </router-link>
            </li>
            <li>
              <a href="tel:07904155651" class="btn">07904 155651</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import MobileMenu from '@/components/partials/MobileMenu'

export default {
  name: 'main-header',
  components: {
    MobileMenu
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.header {
  background-color: $theme-primary-bg;

  .router-link-active {
    text-decoration: underline;
    text-decoration-color: $clr-theme-black;
    color: $theme-primary-text;
  }

  .btn {
    font-size: 16px;
  }

  padding: 18px 0;

  &-logo-link-img {
    max-width: 180px;
    max-height: 180px;
    @media screen and (min-width: $md-breakpoint) {
      max-width: 250px;
    }
  }

  &-navigation {
    &-wrapper {
      margin: 0;

      @media screen and (min-width: $lg-breakpoint) {
        margin: auto 0;
      }
    }

    &-items {
      margin: 0;
      padding: 0;
      font-size: 16px;
      list-style-type: none;
      display: none;
      justify-content: space-between;
      align-items: center;

      > li + li {
        margin-left: 2rem;
      }

      @media screen and (min-width: $lg-breakpoint) {
        display: flex;
      }

      &-link {
        font-weight: 700;
        color: $theme-primary-text;
        text-transform: uppercase;

        &:hover {
          color: $theme-primary-text;
          text-decoration-color: $clr-theme-black;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue